import React from 'react';
import {FormattedMessage} from 'react-intl';
import {bool, func, object, string} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {basicForm} from 'utils/helpers';
import config from './awardPointsFormConfig';
import {Label} from "semantic-ui-react";

const AwardPointsForm = basicForm(config);

const AwardPointsModal = props => (
  <BasicModal
    header={<FormattedMessage id='userManagement.userDetail.modals.awardPoints.header' values={{email: props.email}} />}
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    dimmer='inverted'
    modalSize='small'
    actions={[
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.awardPoints.cancel' />,
        action: props.handleClose,
        isDisabled: props.awarding,
        displayType: 'menu-item'
      },
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.awardPoints.submit' />,
        action: props.submit,
        loading: props.awarding,
        isDisabled: props.hasErrors || false,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <AwardPointsForm
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
      {props.error ? (
          <Label basic className="db-error-label">
              <FormattedMessage id={props.error}/>&nbsp;
          </Label>
      ) : ""}
  </BasicModal>
);

AwardPointsModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,
  handleClose: func.isRequired,
  email: string,
  modalOpen: bool.isRequired,
  awarding: bool
};

export default AwardPointsModal;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardPointsModal/AwardPointsModal.jsx